import { apiRequest } from "../util/apiUtils";

export const subscriptionListFont = async (params) => {
  try {
    const res = await apiRequest("get", `/subscription/list-front`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const subscriptionList = async (params) => {
  try {
    const res = await apiRequest("get", `subscription/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const donorSubscriptionList = async (params) => {
  try {
    const res = await apiRequest("get", `subscription/list-user`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const subscriptionAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `subscription/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const subscriptionDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `subscription/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const subscriptionStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `subscription/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const CreatePayment = async (payload) => {
  try {
    const res = await apiRequest(
      "post",
      `payment/stripe/plan-create-with-payment-intent`,
      {
        body: payload,
      }
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};
